<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xl3 lg4 md5 sm6>
        <v-layout row wrap>
          <v-flex>
            <v-card class="elevation-12 pa-5 py-8">
              <v-layout>
                <v-flex>
                  <h1 color="white">{{ $t("modules.notFound.message") }}</h1>
                  <v-btn @click="back_to_home_page()" id="goBackToHome__button">
                    <v-icon>mdi-keyboard-backspace</v-icon>
                    {{ $t("modules.notFound.goBackMessage") }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "NotFoundPage",
  methods: {
    back_to_home_page() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
